import { render, staticRenderFns } from "./comply-advantage-case-management.vue?vue&type=template&id=82988920&scoped=true&"
import script from "./comply-advantage-case-management.vue?vue&type=script&lang=js&"
export * from "./comply-advantage-case-management.vue?vue&type=script&lang=js&"
import style0 from "./comply-advantage-case-management.vue?vue&type=style&index=0&id=82988920&scoped=true&lang=css&"
import style1 from "./comply-advantage-case-management.vue?vue&type=style&index=1&lang=css&"
import style2 from "./comply-advantage-case-management.vue?vue&type=style&index=2&id=82988920&scoped=true&lang=css&"
import style3 from "./comply-advantage-case-management.vue?vue&type=style&index=3&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82988920",
  null
  
)

export default component.exports